// Template Generated by DataExtraction.py at 1716507313

import SKYCMaternity1English from "../../Forms/SKYC/SKYC-Maternity1English.png";
import SKYCMaternity1EnglishLabels from "../../Labels/SKYC/SKYC-Maternity1English.json";
import SKYCMaternity1French from "../../Forms/SKYC/SKYC-Maternity1French.png";
import SKYCMaternity1FrenchLabels from "../../Labels/SKYC/SKYC-Maternity1French.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab,
    formatDayFromDate,
    formatMonthFromDate,
    formatYearFromDate,
    drawText as drawTextAtPos,
    isChildCareCheckExpense
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";
import { displayCurrency } from "../../../Utils/FormattingUtils";


import moment from "moment/moment";
import {
    calculateAgeOfYoungestBeneficiary,
    calculateApproximateNetWorth,
    calculateMaxEducationSavingsPlans,
    calculateMonthlyIncomeGross,
    calculateMonthlyIncomeGrossAfterMat,
    calculateMonthlyIncomeNet, calculateMonthlyIncomeNetAfterMat,
    calculateTimeHorizon,
    calculateTotalFinancialAssets,
    calculateYearlyIncomeGross, calculateYearlyIncomeGrossAfterMat,
    isEightyYearRuleExceeded,
    monthlyAvailableSavingsForRespContributions
} from "../../../Utils/KYCUtils";
import { t } from "i18next";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? SKYCMaternity1FrenchLabels : SKYCMaternity1EnglishLabels;
    const formImage = isFrench ? SKYCMaternity1French : SKYCMaternity1English;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label, colorOverride = null) {
        drawTextOnLabel(doc, value, label, labels, colorOverride);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const common = data.common;
    const kyc = data.knowYourClient;
    const plan = data.plan;

    const planTypeID = plan.planTypeID;

    const subscriber2Include = common.subscriber2Include;
    const application = data.application;


    const s1Name = subscriber.firstName + (subscriber.lastName ? " " + subscriber.lastName : "");
    const s2Name = jointSubscriber.firstName + (jointSubscriber.lastName ? " " + jointSubscriber.lastName : "");

    const d1 = data.dependant;
    const d2 = data.dependant2;
    const d3 = data.dependant3;
    const d4 = data.dependant4;
    const d5 = data.dependant5;

    const beneficiary = data.beneficiary;

    const dateFormat = "MM/DD/yyyy";

    const planTypeMappings = {
        "-1": "",
        0: "Group",
        1: "Self-Initiated",
        2: "Achievers",
    }

    const planType = planTypeMappings[planTypeID];

    // Drawing the form
    if (planTypeID === 0) { // Group
        drawText(t("Yes"), "affordabilityYesNo");
    } else if (planTypeID === 1) { // Self-Initiated
        drawText(t("No"), "affordabilityYesNo");
    } else if (planTypeID === 2) { // Achievers
        drawText(t("Yes"), "affordabilityYesNo");
    }

    //Absorb any loss text
    drawTextAtPos(doc, 12, t("Yes"), 645 / 3.38, 590 / 3.38, 464 / 3.38);

    drawText(kyc.afterMaternityLeaveEnds, "afterMaternityLeaveEnds");
    drawText(`${calculateAgeOfYoungestBeneficiary(beneficiary, kyc)}`, "ageOfYoungestBene");
    drawText(kyc.anticipateKeepContributions ? t("Yes") : t("No"), "anticipateKeepContributions");
    drawText(kyc.pepYN ? t("Yes") : t("No"), "PEPYN", kyc.pepYN ? {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    } : null);    
    drawText(displayCurrency(calculateApproximateNetWorth(kyc), i18n.language), "approxNetWorth");
    drawText(displayCurrency(kyc.availableSavingsForRespContributions, i18n.language), "availableSavingsForRespContributions");
    drawText(displayCurrency(kyc.ccbMonthlyIncomeGross, i18n.language), "ccbGross");
    drawText(displayCurrency(kyc.ccbMonthlyIncomeGrossAfterMat, i18n.language), "ccbGrossAfterMat");
    drawText(displayCurrency(kyc.ccbMonthlyIncomeGross, i18n.language), "ccbNet"); // same as gross?
    drawText(displayCurrency(kyc.ccbMonthlyIncomeGrossAfterMat, i18n.language), "ccbNetAfterMat"); // same as gross?
    drawText(isChildCareCheckExpense(kyc) ? t("Confirm Expense!") : "", "childCareCheckExpense");

    if (kyc.numberOfDependants >= 1) {
        // d1
        drawText(d1.yearsOfEducationalSupport, "d1Edu");
        let d1Name = d1.name;
        let d1Birthdate = moment(d1.birthdate).format(dateFormat);

        if (kyc.beneficiaryIsADependant) {
            d1Name = beneficiary.firstName + (beneficiary.lastName ? " " + beneficiary.lastName : "");
            d1Birthdate = moment(beneficiary.birthdate).format(dateFormat);
        }

        drawText(d1Name, "d1Name");
        drawText(d1Birthdate, "d1Birthdate");
    }

    if (kyc.numberOfDependants >= 2) {
        // d2
        drawText(moment(d2.birthdate).format(dateFormat), "d2Birthdate");
        drawText(d2.yearsOfEducationalSupport, "d2Edu");
        drawText(d2.name, "d2Name");
    }
    if (kyc.numberOfDependants >= 3) {
        // d3
        drawText(moment(d3.birthdate).format(dateFormat), "d3Birthdate");
        drawText(d3.yearsOfEducationalSupport, "d3Edu");
        drawText(d3.name, "d3Name");
    }
    if (kyc.numberOfDependants >= 4) {
        // d4
        drawText(moment(d4.birthdate).format(dateFormat), "d4Birthdate");
        drawText(d4.yearsOfEducationalSupport, "d4Edu");
        drawText(d4.name, "d4Name");
    }

    if (kyc.numberOfDependants >= 5) {
        // d5
        drawText(moment(d5.birthdate).format(dateFormat), "d5Birthdate");
        drawText(d5.yearsOfEducationalSupport, "d5Edu");
        drawText(d5.name, "d5Name");
    }
    function drawLongText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, false, true);
    }

    drawText(displayCurrency(kyc.deposits, i18n.language), "deposits");
    drawText(isEightyYearRuleExceeded(subscriber, jointSubscriber, kyc, common) ? t("Note deposit schedule and subscriber's 80th birthday") : "", "eightyYearRule", isEightyYearRuleExceeded(subscriber, jointSubscriber, kyc, common) ? {
        r: 255,
        g: 0,
        b: 0,
        a: 255
    } : null);
    drawText(kyc.existingSubscriber ? t("Yes") : t("No"), "existingSubscriber");
    drawText(common.borrowingToInvest ? t("Yes") : t("No"), "leveraging", common.borrowingToInvest ? { r: 255, g: 0, b: 0, a: 255 } : null);
    drawText(displayCurrency(kyc.liabilities, i18n.language), "liabilities");
    drawText(kyc.locationAndTypeOfSavings, "locationAndTypeOfSavings");
    drawText(kyc.maternityLeave ? t("YES") : t("NO"), "maternityLeave");
    drawLongText(kyc.drReason, "drReason");
    drawText(displayCurrency(monthlyAvailableSavingsForRespContributions(kyc), i18n.language), "monthlyAvailableSavingsForRespContributions");
    drawText(kyc.objective, "objective");
    drawText(displayCurrency(kyc.otherAssets, i18n.language), "otherAssets");
    drawText(displayCurrency(kyc.otherMonthlyIncomeGross, i18n.language), "otherGross");
    drawText(displayCurrency(kyc.otherMonthlyIncomeGrossAfterMat, i18n.language), "otherGrossAfterMat");
    drawText(displayCurrency(kyc.otherMonthlyIncomeNet, i18n.language), "otherNet");
    drawText(displayCurrency(kyc.otherMonthlyIncomeNetAfterMat, i18n.language), "otherNetAfterMat");
    drawText(t(planType), "planType");
    drawText(moment(kyc.returnToWorkDate).format("MM"), "returnToWorkDateMM");
    drawText(moment(kyc.returnToWorkDate).format("YYYY"), "returnToWorkDateYYYY");
    drawText(t(kyc.riskTolerance), "riskTolerance");

    drawText(formatDayFromDate(subscriber.birthdate), "s1DobDay");
    drawText(formatMonthFromDate(subscriber.birthdate), "s1DobMonth");
    drawText(formatYearFromDate(subscriber.birthdate), "s1DobYear");
    drawText(subscriber.employer, "s1Employer");
    drawText(displayCurrency(subscriber.monthlyIncomeGross, i18n.language), "s1Gross");
    drawText(displayCurrency(subscriber.monthlyIncomeGrossAfterMat, i18n.language), "s1GrossAfterMat");
    drawText(t(subscriber.investmentExperience), "s1InvestmentExperience");
    drawText(subscriber.investmentTypes, "s1InvestmentTypes");
    drawText(s1Name, "s1Name");
    drawText(displayCurrency(subscriber.monthlyIncomeNet, i18n.language), "s1Net");
    drawText(displayCurrency(subscriber.monthlyIncomeNetAfterMat, i18n.language), "s1NetAfterMat");

    drawText(subscriber.occupation, "s1Occupation");
    if (subscriber2Include) {
        drawText(formatDayFromDate(jointSubscriber.birthdate), "s2DobDay");
        drawText(formatMonthFromDate(jointSubscriber.birthdate), "s2DobMonth");
        drawText(formatYearFromDate(jointSubscriber.birthdate), "s2DobYear");
        drawText(jointSubscriber.employer, "s2Employer");
        drawText(displayCurrency(jointSubscriber.monthlyIncomeGross, i18n.language), "s2Gross");
        drawText(displayCurrency(jointSubscriber.monthlyIncomeGrossAfterMat, i18n.language), "s2GrossAfterMat");
        drawText(t(jointSubscriber.investmentExperience), "s2InvestmentExperience");
        drawText(jointSubscriber.investmentTypes, "s2InvestmentTypes");
        drawText(s2Name, "s2Name");
        drawText(displayCurrency(jointSubscriber.monthlyIncomeNet, i18n.language), "s2Net");
        drawText(displayCurrency(jointSubscriber.monthlyIncomeNetAfterMat, i18n.language), "s2NetAfterMat");
        drawText(jointSubscriber.occupation, "s2Occupation");
    }

    drawText(displayCurrency(kyc.securities, i18n.language), "securities"); // after mat?
    drawText(application.tcpEmail, "tcpEmail");
    drawText(application.tcpName, "tcpName");
    drawText(application.tcpPhone, "tcpPhone");
    drawText(application.tcpRelationship, "tcpRelationship");
    drawText(calculateTimeHorizon(beneficiary, kyc), "timeHorizon");
    drawText(displayCurrency(calculateTotalFinancialAssets(kyc), i18n.language), "totalFinancialAssets");
    drawText(displayCurrency(calculateMonthlyIncomeGross(subscriber, jointSubscriber, kyc), i18n.language), "totalGross");
    drawText(displayCurrency(calculateMonthlyIncomeGrossAfterMat(subscriber, jointSubscriber, kyc), i18n.language), "totalGrossAfterMat");
    drawText(displayCurrency(calculateMonthlyIncomeNet(subscriber, jointSubscriber, kyc), i18n.language), "totalNet");
    drawText(displayCurrency(calculateMonthlyIncomeNetAfterMat(subscriber, jointSubscriber, kyc), i18n.language), "totalNetAfterMat");
    drawText(displayCurrency(calculateYearlyIncomeGross(subscriber, jointSubscriber, kyc), i18n.language), "yearlyIncomeGross");
    drawText(displayCurrency(calculateYearlyIncomeGrossAfterMat(subscriber, jointSubscriber, kyc), i18n.language), "yearlyIncomeGrossAfterMat");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? SKYCMaternity1FrenchLabels : SKYCMaternity1EnglishLabels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
